const useIndexedDB = () => {
  const deleteDB = (dbToSave) => {
    const databaseNames = ['main', 's1', `${import.meta.env.REACT_APP_CCMS_VERSION}`];
    const databasesToDelete = databaseNames.filter(function(dbName) {
      return dbName !== dbToSave;
    });

    const deleteDatabase = (databaseName) => {
      const request = indexedDB.open(databaseName);

      request.onsuccess = function (event) {
        // const db = event.target.result;

        const deleteRequest = indexedDB.deleteDatabase(databaseName);

        deleteRequest.onsuccess = function(event) {
          console.log(`Database ${databaseName} deleted successfully`);
        };
  
        deleteRequest.onerror = function(event) {
          console.log(`Error deleting database ${databaseName}: ${event.target.errorCode}`);
        };
      }

      request.onerror = function(event) {
        console.log(`Error opening database ${databaseName}: ${event.target.errorCode}`);
      };
    }

    databasesToDelete.forEach(function(dbName) {
      deleteDatabase(dbName);
    });
  }

  return { deleteDB }
};

export default useIndexedDB;
